<template>
    <div>
        <div :style="{color: 'red'}">DIFFICULTY BASE ON:</div>
        <v-treeview :items="itemsTree">
            <template v-slot:label="{ item }">
                <div>
                    {{item.name}} : <strong> {{ item.value }}</strong> <br/>
                </div>
            </template>
        </v-treeview>
    </div>
</template>

<script>
import SMPNum from "@/SMPNum";

export default {
    name: "GroupSurviveTimeInTreeView",
    props: ['payload'],
    watch: {
        payload(newVal, oldVal){
            if (oldVal) {
                // optional: clean up or nullify old references
                oldVal = null;
            }
        }
    },
    data() {
        return {
        }
    },
    methods: {
        getSurviveOnNB(){
            return {
                id: 1,
                name: 'Survive-NB',
                value: this.kpiHeroPossibleSurvive,
                children: [{
                    id: 2,
                    name: 'PossibleHeroHP',
                    value: this.kpiTotalHeroHpOnBoss,
                    children: [
                        {
                            id: 3,
                            name: 'HeroHP',
                            value: this.kpiHeroHp,
                            children: [
                                {
                                    id: 4,
                                    name: `BaseHP(${this.kpiHeroLevel})`,
                                    value: this.kpiBaseHeroHp,
                                }, {
                                    id: 5,
                                    name: 'SupportElementHP',
                                    value: this.kpiHeroHpFromSupportsBonus,
                                },
                            ],
                        }, {
                            id: 6,
                            name: 'GenHP-NB',
                            value: this.kpiExpectedGeneratedHpWithBoss,
                        }, {
                            id: 7,
                            name: 'Time-NB',
                            value: this.kpiTimeHeroPossibleDieWithNormalBoss
                        },{
                            id: 8,
                            name: 'ItemHP',
                            value: this.kpiItemHp,
                        }
                    ],
                }, {
                    id: 9,
                    name: 'DPS-NB',
                    value: this.kpiBossDps,
                }
                ],
            };
        },
        getSurviveOnZB(){
            return {
                id: 20,
                name: 'Survive-ZB',
                value: this.kpiHeroPossibleSurviveZoneBoss,
                children: [{
                    id: 21,
                    name: 'PossibleHeroHP',
                    value: this.kpiTotalHeroHpOnZoneBoss,
                    children: [
                        {
                            id: 22,
                            name: 'HeroHP',
                            value: this.kpiHeroHp,
                            children: [
                                {
                                    id: 23,
                                    name: `BaseHP(${this.kpiHeroLevel})`,
                                    value: this.kpiBaseHeroHp,
                                }, {
                                    id: 24,
                                    name: 'SupportElementHP',
                                    value: this.kpiHeroHpFromSupportsBonus,
                                },
                            ],
                        }, {
                            id: 25,
                            name: 'GenHP-ZB',
                            value: this.kpiExpectedGeneratedHpWithZoneBoss,
                        }, {
                            id: 26,
                            name: 'Time-ZB',
                            value: this.kpiTimeHeroPossibleDieWithZoneBoss
                        },{
                            id: 27,
                            name: 'ItemHP',
                            value: this.kpiItemHp,
                        }
                    ],
                }, {
                    id: 28,
                    name: 'DPS-ZB',
                    value: this.kpiZoneBossDps,
                }
                ],
            };
        },

        getTTKNB(){
            return {
                id: 40,
                name: 'TTKNB',
                value: this.timeToKillBossReadable,
                children: [{
                    id: 41,
                    name: 'NBHP',
                    value: this.kpiNormalBossHp,
                }, {
                    id: 42,
                    name: 'BestDPS',
                    value: this.kpiTotalDpsKillBoss,
                    children: [{
                        id: 43,
                        name: 'ΣDPS',
                        value: this.kpiHeroAndPetDpsOnBoss,
                        children: [{
                            id: 44,
                            name: 'HeroDPS',
                            value: this.kpiHeroDpsOnBoss,
                            children: [{
                                id: 47,
                                name: `TapDmg(${this.kpiHeroLevelOnBoss})`,
                                value: this.kpiHeroBaseDmgOnBoss,
                            }, {
                                id: 48,
                                name: 'PetElementTypeDmg',
                                value: this.kpiDmgPetElementType,
                            }, {
                                id: 49,
                                name: 'BossElementTypeDmg',
                                value: this.kpiDmgFromBossElementType,
                            }, {
                                id: 50,
                                name: 'HitPerSecond',
                                value: this.hitPerSecondOnBoss,
                            }]
                        }, {
                            id: 45,
                            name: 'PetDPS',
                            value: this.kpiPetDpsOnBoss,
                        }, {
                            id: 46,
                            name: 'ItemDPS',
                            value: this.kpiItemDpsOnBoss,
                        }]
                    }, {
                        id: 51,
                        name: 'SupportAVGDPS',
                        value: this.kpiSupportDpsOnBoss,
                    },],
                },
                ],
            };
        },

        getTTKZB(){
            return {
                id: 60,
                name: 'TTKZB',
                value: this.timeToKillZBossReadable,
                children: [{
                    id: 61,
                    name: 'ZBHP',
                    value: this.kpiZoneBossHp,
                }, {
                    id: 62,
                    name: 'BestDPS',
                    value: this.kpiTotalDpsKillZBoss,
                    children: [{
                        id: 63,
                        name: 'ΣDPS',
                        value: this.kpiHeroAndPetDpsOnZBoss,
                        children: [{
                            id: 64,
                            name: 'HeroDPS',
                            value: this.kpiHeroDpsOnZBoss,
                            children: [{
                                id: 67,
                                name: `TapDmg(${this.kpiHeroLevelOnZBoss})`,
                                value: this.kpiHeroBaseDmgOnZBoss,
                            }, {
                                id: 68,
                                name: 'PetElementTypeDmg',
                                value: this.kpiDmgPetElementType,
                            }, {
                                id: 69,
                                name: 'BossElementTypeDmg',
                                value: this.kpiDmgFromBossElementType,
                            }, {
                                id: 70,
                                name: 'HitPerSecond',
                                value: this.hitPerSecondOnZBoss,
                            }]
                        }, {
                            id: 65,
                            name: 'PetDPS',
                            value: this.kpiPetDpsOnZBoss,
                        }, {
                            id: 66,
                            name: 'ItemDPS',
                            value: this.kpiItemDpsOnZBoss,
                        }]
                    }, {
                        id: 71,
                        name: 'SupportAVGDPS',
                        value: this.kpiSupportDpsOnZBoss,
                    },],
                },
                ],
            };
        },
    },

    computed: {
        itemsTree(){
            const items = [];
            if(this.isNormalBossMode){
                items.push(this.getTTKNB());
                items.push(this.getSurviveOnNB());
            } else {
                items.push(this.getTTKZB());
                items.push(this.getSurviveOnZB());
            }
            return items;
        },

        //common
        kpiBaseHeroHp() {
            const {kpiBaseHeroHp} = this.payload;
            return kpiBaseHeroHp.ToReadableAlphabetV2();
        },
        kpiHeroHp(){
            const {kpiHeroHp} = this.payload;
            return kpiHeroHp.ToReadableAlphabetV2();
        },
        kpiHeroHpFromSupportsBonus(){
            const {heroHpCapSessionFromSupport} = this.payload;
            return heroHpCapSessionFromSupport.bonusHp.ToReadableAlphabetV2();
        },
        kpiItemHp(){
            const {kpiHpItemBonus} = this.payload;
            return kpiHpItemBonus.ToReadableAlphabetV2();
        },
        kpiHeroLevel(){
            const {heroLevelAfterFarm} = this.payload;
            return heroLevelAfterFarm;
        },
        isNormalBossMode (){
            const {bossInfo} = this.payload;
            if (bossInfo.kpiBossType === 'NormalBoss') {
                return true;
            }
            return false;
        },
        kpiHeroBaseDmg() {
            const {kpiHeroBaseDmg} = this.payload;
            return kpiHeroBaseDmg.ToReadableAlphabetV2();
        },
        kpiDmgPetElementType(){
            const {heroDmgSessionFromPet} = this.payload;

            if(heroDmgSessionFromPet.bonusDmg.isZero){
                return '0';
            } else{
                return heroDmgSessionFromPet.bonusDmg.ToReadableAlphabetV2();
            }
        },
        kpiDmgFromBossElementType(){
            const {heroDmgSessionGainBoss} = this.payload;

            if(heroDmgSessionGainBoss.bonusPercent === 0){
                return '0';
            } else if(heroDmgSessionGainBoss.isGain){
                return `+${heroDmgSessionGainBoss.bonusDmg.ToReadableAlphabetV2()}`;
            } else {
                return `-${heroDmgSessionGainBoss.bonusDmg.ToReadableAlphabetV2()}`;
            }
        },

        //Normal Boss tree
        kpiHeroPossibleSurvive (){
            const {kpiHeroPossibleSurvive} = this.payload;
            return SMPNum.ToReadableTimeValue(kpiHeroPossibleSurvive);
        },
        kpiExpectedGeneratedHpWithBoss (){
            const {kpiExpectedGeneratedHpWithBoss} = this.payload;
            return kpiExpectedGeneratedHpWithBoss.ToReadableAlphabetV2();
        },
        kpiTotalHeroHpOnBoss() {
            const {kpiHeroPossibleSurvive, kpiBossDps} = this.payload;
            return SMPNum.multSmpNum(kpiHeroPossibleSurvive, kpiBossDps).ToReadableAlphabetV2();
        },
        kpiBossDps() {
            const {kpiBossDps} = this.payload;
            return kpiBossDps.ToReadableAlphabetV2();
        },
        kpiTimeHeroPossibleDieWithNormalBoss() {
            const {kpiTimeHeroPossibleDieWithNormalBoss} = this.payload;
            return SMPNum.ToReadableTimeValue(kpiTimeHeroPossibleDieWithNormalBoss);
        },

        //Zone Boss tree
        kpiHeroPossibleSurviveZoneBoss (){
            const {kpiHeroPossibleSurviveZoneBoss} = this.payload;
            return SMPNum.ToReadableTimeValue(kpiHeroPossibleSurviveZoneBoss);
        },
        kpiExpectedGeneratedHpWithZoneBoss (){
            const {kpiExpectedGeneratedHpWithZoneBoss} = this.payload;
            return kpiExpectedGeneratedHpWithZoneBoss.ToReadableAlphabetV2();
        },
        kpiTotalHeroHpOnZoneBoss() {
            const {kpiHeroPossibleSurviveZoneBoss, kpiZoneBossDps} = this.payload;
            return SMPNum.multSmpNum(kpiHeroPossibleSurviveZoneBoss, kpiZoneBossDps).ToReadableAlphabetV2();
        },
        kpiZoneBossDps() {
            const {kpiZoneBossDps} = this.payload;
            return kpiZoneBossDps.ToReadableAlphabetV2();
        },
        kpiTimeHeroPossibleDieWithZoneBoss() {
            const {kpiTimeHeroPossibleDieWithZoneBoss} = this.payload;
            return SMPNum.ToReadableTimeValue(kpiTimeHeroPossibleDieWithZoneBoss);
        },

        //TTKNB Tree
        timeToKillBossReadable() {
            const {kpiKillBossPayLoad: {timeToKillBoss}} = this.payload;
            return SMPNum.ToReadableTimeValue(timeToKillBoss);
        },
        kpiNormalBossHp() {
            const {kpiNormalBossHp} = this.payload;
            return kpiNormalBossHp.ToReadableAlphabetV2();
        },
        kpiTotalDpsKillBoss(){
            const {kpiKillBossPayLoad: {totalDps}} = this.payload;
            return totalDps.ToReadableAlphabetV2();
        },
        kpiHeroAndPetDpsOnBoss(){
            const {kpiKillBossPayLoad: {heroDps, petDps, itemDps}} = this.payload;
            return SMPNum.plus(heroDps, SMPNum.plus(petDps, itemDps)).ToReadableAlphabetV2();
        },
        kpiHeroDpsOnBoss() {
            const {kpiKillBossPayLoad: {heroDps}} = this.payload;
            return heroDps.ToReadableAlphabetV2();
        },
        kpiPetDpsOnBoss() {
            const {kpiKillBossPayLoad: {petDps}} = this.payload;
            return petDps.ToReadableAlphabetV2();
        },
        kpiSupportDpsOnBoss() {
            const {kpiKillBossPayLoad: {supportDps}} = this.payload;
            return supportDps.ToReadableAlphabetV2();
        },
        kpiItemDpsOnBoss(){
            const {kpiKillBossPayLoad: {itemDps}} = this.payload;
            return itemDps.ToReadableAlphabetV2();
        },
        kpiHeroLevelOnBoss(){
            const {kpiKillBossPayLoad: {heroLevel}} = this.payload;
            return heroLevel;
        },
        hitPerSecondOnBoss(){
            const {kpiKillBossPayLoad: {hitPerSecond}} = this.payload;
            return hitPerSecond;
        },
        kpiHeroBaseDmgOnBoss() {
            const {kpiKillBossPayLoad: {heroDmg}} = this.payload;
            return heroDmg.ToReadableAlphabetV2();
        },

        //TTKZB Tree
        timeToKillZBossReadable() {
            const {kpiKillZoneBossPayLoad: {timeToKillZoneBoss}} = this.payload;
            return SMPNum.ToReadableTimeValue(timeToKillZoneBoss);
        },
        kpiZoneBossHp() {
            const {kpiZoneBossHp} = this.payload;
            return kpiZoneBossHp.ToReadableAlphabetV2();
        },
        kpiTotalDpsKillZBoss(){
            const {kpiKillZoneBossPayLoad: {totalDps}} = this.payload;
            return totalDps.ToReadableAlphabetV2();
        },
        kpiHeroAndPetDpsOnZBoss(){
            const {kpiKillZoneBossPayLoad: {heroDps, petDps, itemDps}} = this.payload;
            return SMPNum.plus(heroDps, SMPNum.plus(petDps, itemDps)).ToReadableAlphabetV2();
        },
        kpiHeroDpsOnZBoss() {
            const {kpiKillZoneBossPayLoad: {heroDps}} = this.payload;
            return heroDps.ToReadableAlphabetV2();
        },
        kpiPetDpsOnZBoss() {
            const {kpiKillZoneBossPayLoad: {petDps}} = this.payload;
            return petDps.ToReadableAlphabetV2();
        },
        kpiSupportDpsOnZBoss() {
            const {kpiKillZoneBossPayLoad: {supportDps}} = this.payload;
            return supportDps.ToReadableAlphabetV2();
        },
        kpiItemDpsOnZBoss(){
            const {kpiKillZoneBossPayLoad: {itemDps}} = this.payload;
            return itemDps.ToReadableAlphabetV2();
        },
        kpiHeroLevelOnZBoss(){
            const {kpiKillZoneBossPayLoad: {heroLevel}} = this.payload;
            return heroLevel;
        },
        hitPerSecondOnZBoss(){
            const {kpiKillZoneBossPayLoad: {hitPerSecond}} = this.payload;
            return hitPerSecond;
        },
        kpiHeroBaseDmgOnZBoss() {
            const {kpiKillZoneBossPayLoad: {heroDmg}} = this.payload;
            return heroDmg.ToReadableAlphabetV2();
        },
    }
}
</script>

<style scoped>
    >>> .v-treeview-node__root {
        min-height: 30px;
    }
</style>